import { createSlice } from "@reduxjs/toolkit";
import { changePassword } from "../../apis/setting/changePassword";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const changePasswordSlice = createSlice({
    name: 'changePassword',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(changePassword.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(changePassword.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(changePassword.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default changePasswordSlice.reducer